export default {
  name: "login",
  component: () => import(/* webpackChunkName: "login" */ "../views/LoginView"),
};
